(function ($) {
    let terms = $('.js-sample-station-terms a');

	if (terms.length) {
        const id = document.querySelector('.js-sample-station-terms a.active').dataset.id;

        // Replace the first page history, so we can load in our state.
        history.replaceState({ type: 'posts', id }, null, window.location.href);

        /**
         * Request new posts from a certain category.
         * @param e Event
         */
        const loadPosts = (e) => {
            e.preventDefault();

            const id = e.currentTarget.dataset.id;

	        terms.removeClass('active');
	        terms.attr('aria-pressed', false);
	        $(e.currentTarget).addClass('active');
	        $(e.currentTarget).attr('aria-pressed', true);

            loadPostsData(id, function (result) {
                document.querySelector('.js-sample-station-container').innerHTML = result.content;
                history.pushState({ type: 'posts', id }, null, e.currentTarget.getAttribute('href'));

	            /**
	             * Remove the existing event listeners & then re-add it. This prevents
	             * multiple event listeners from stacking & lets us add it to the
	             * newly added content.
	             */
	            terms.off('click', loadPosts);
	            terms = $('.js-sample-station-terms a');
	            terms.on('click', loadPosts);
            });
        };

        const loadPostsData = (id, successCallback) => {
            $.ajax({
                url: vi.ajax_url,
                type: 'GET',
                data: {
                    security: vi.security,
                    action: 'sample_station_filter',
                    category: id,
                },
                dataType: 'json',
                success: successCallback,
                error: function (error) {
                    console.log('error :( ');
                }
            })
        };

        /**
         * Event listeners
         */
        terms.on('click', loadPosts);

		window.addEventListener('popstate', function (e) {
            if (e.state && e.state.type === 'posts') {
                loadPostsData(e.state.id, function (result) {
                    terms.removeClass('active');
                    $(`[data-id=${e.state.id}]`).addClass('active');
                    document.querySelector('.js-sample-station-container').innerHTML = result.content;
                });
            }
        });
    }
})(jQuery);
